export default __webpack_public_path__ + "static/media/team63.aacc8676.JPG";